import { gql } from "apollo-boost"

export const GET_REQUEST_F21 = gql`
query REQUEST_F21_DATA ($projectId: ID!) {
  ProjectBeneficiariesByProjectWithF21Data(
    projectId: $projectId
  ) {
    id
    number
    isBlocking
    isBlockingParticipants
    ultimateEfficiency
    attendeeNumber
    callStrategy
    ultimateEfficiencyJustification,
    multiRegion
    beneficiaryActivitiesCompletion {
    completedNumber
     beneficiaryGroups {
     id
     }
      activity {
        id
        title
        goal
      }
    }
    beneficiaryIndicatorsCommitment {
      id
      indicatorsChangeJustification
      expectedBeneficiaryIndicatorsChange{
        id
        changeExpected
        indicator{
          id
          title
          specificObjective {
          	id
        		orderIndex

          }
        }
      }
      expectedBeneficiaryIndicatorsChange{
        id
        changeExpected
        expectedChangeJustification
        indicator{
          id
          title
          orderIndex
          specificObjective {
          	id
        		orderIndex

          }
        }
      }
      beneficiaryWillAchieveGOIndicatorChange
      beneficiaryGoIndicatorsRelationship {
        id
        isProfileRelated
        indicator {
          id
          title
          orderIndex
          description
          specificObjective {
          	id
            description
          }
        }
      }
    }
    beneficiaryGroups {
    id
    groupName
  }
  }
}
`
